import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-horizontal",
  "use": "svg_i-horizontal-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"svg_i-horizontal\"><path d=\"M0 0h6v3H0V0zm7 10h6v3H7v-3zm-7 0h5v3H0v-3zm0-5h13v3H0V5zm8-5h5v3H8V0z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol